<template>
    <div>
        <a-row>
            <a-col :span="24" style="margin-bottom: 10px;border-bottom: 1px solid #f0f2f5;">
                <a-row type="flex" justify="start">
                    <a-col :span="20" :style="{textAlign: 'left',padding: '10px 0 0 20px'}">
                        <span style="font-size: 1.6em;">添加网站</span>
                    </a-col>
                    <a-col :span="4" :style="{textAlign: 'right', padding: '10px 20px 10px 0'}">
                        <router-link to="/admin/website">
                            <a-button type="primary">
                                返回列表
                            </a-button>
                        </router-link>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="16" :offset="4" :style="{padding: '10px 24px 24px 24px'}">
                <a-form-model
                    ref="ruleForm"
                    :model="form"
                    :rules="rules"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
                >
                    <a-form-model-item ref="title" label="网站名称" prop="title">
                        <a-input v-model="form.title"/>
                    </a-form-model-item>
                    <a-form-model-item ref="company" label="公司名称" prop="company">
                        <a-input v-model="form.company"/>
                    </a-form-model-item>
                    <a-form-model-item label="网站模板" prop="templates">
                        <a-select v-model="form.templates" placeholder="请选择网站模板">
                            <a-select-option v-for="item in templates" :key="item.val" :value="item.val">
                                {{ item.title }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>

                    <a-form-model-item ref="host" label="网站域名" prop="host">
                        <a-input v-model="form.host"/>
                    </a-form-model-item>

                    <a-form-model-item ref="beian" label="备案号" prop="beian">
                        <a-input v-model="form.beian"/>
                    </a-form-model-item>

                    <a-form-model-item ref="wxCode" label="微信号" prop="wxCode">
                        <a-input v-model="form.wxCode"/>
                    </a-form-model-item>

                    <a-form-model-item ref="phone" label="手机号" prop="phone">
                        <a-input v-model="form.phone"/>
                    </a-form-model-item>

                    <a-form-model-item ref="keywords" label="关键词" prop="keywords">
                        <a-input v-model="form.keywords"/>
                    </a-form-model-item>

                    <a-form-model-item label="网站描述" prop="descInfo">
                        <a-input v-model="form.descInfo" type="textarea"/>
                    </a-form-model-item>

                    <a-form-model-item label="统计代码" prop="statistics">
                        <a-input v-model="form.statistics" type="textarea"/>
                    </a-form-model-item>

                    <a-form-model-item label="网站Logo" style="text-align: left">
                        <a-upload
                            name="file"
                            :multiple="false"
                            :action="uploadHost"
                            :headers="headers"
                            :before-upload="picSignature"
                            :data="uploadData"
                            @change="handleChange"
                        >
                            <a-button>
                                <a-icon type="upload"/>
                                点击上传
                            </a-button>
                            <div style="font-size:14px;">图片建议尺寸：1920*1080</div>
                            <div>
                                <img v-if="form.logo !== null && form.logo!== undefined" :src=getPic(form.logo) style="width: 100%" />
                            </div>
                        </a-upload>
                    </a-form-model-item>

                    <a-form-model-item label="微信二维码" style="text-align: left">
                        <a-upload
                            name="file"
                            :multiple="false"
                            :action="uploadHost"
                            :headers="headers"
                            :before-upload="picSignature"
                            :data="uploadData"
                            @change="handleChange2"
                        >
                            <a-button>
                                <a-icon type="upload"/>
                                点击上传
                            </a-button>
                            <div style="font-size:14px;">微信二维码，扫码加好友</div>
                            <div>
                                <img v-if="form.wxPic !== null && form.wxPic!== undefined" :src=getPic(form.wxPic) />
                            </div>
                        </a-upload>
                    </a-form-model-item>


                    <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                        <a-button v-if="$route.params.website === 'add'" type="primary" @click="onSubmit">
                            新建网站
                        </a-button>
                        <a-button v-else type="primary" @click="onSubmit">
                            保存
                        </a-button>
                        <a-button style="margin-left: 10px;" @click="resetForm">
                            重置
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </a-col>
        </a-row>
    </div>
</template>

<script>

export default {
    name: "WebsiteAdd",
    data() {
        return {
            labelCol: {span: 4},
            wrapperCol: {span: 14},
            form: {

            },
            templates: [],
            rules: {
                title: [
                    {required: true, message: '网站标题必须输入', trigger: 'blur'},
                    {min: 4, max: 200, message: '网站标题在4-200个汉字长度范围', trigger: 'blur'},
                ],
                company: [
                    {required: true, message: '公司名称必须输入', trigger: 'blur'},
                    {min: 4, max: 30, message: '公司名称在4-30个汉字长度范围', trigger: 'blur'},
                ],
                templates: {required: true, message: '必须选择网站模板', trigger: 'change'},
                phone: [
                    {required: true, message: '手机号必须输入', trigger: 'blur'},
                    {min: 11, max: 11, message: '手机号长度11位', trigger: 'blur'},
                ],
                host: [
                    {required: true, message: '域名必须输入', trigger: 'blur'},
                    {min: 2, max: 30, message: '域名长度2-30个字符', trigger: 'blur'},
                ],
                wxCode: {required: true, message: '微信号必须输入', trigger: 'blur'},
                descInfo: [{required: true, message: '网站描述信息必须输入', trigger: 'blur'}],
                keywords: [{required: true, message: '网站关键词必须输入', trigger: 'blur'}],
            },
            headers: {
                'x-oss-object-acl': 'public-read'
            },
            uploadHost: '',
            uploadData: {},
        };
    },
    methods: {
        getPic(pic) {
            return this.$host + "/admin/pic/read?pic=" + pic;
        },
        picSignature() {
            let that = this
            return this.$ajax.get(this.$host + "/admin/pic/uploadSig", {
                params: {}
            }).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.uploadHost = 'http://' + result.data.host;
                    that.uploadData.key = result.data.path;
                    that.uploadData.policy = result.data.policy;
                    that.uploadData.OSSAccessKeyId = result.data.accessId;
                    that.uploadData.signature = result.data.signature;
                } else {
                    return Promise.reject();
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        handleChange(info) {
            if (info.file.status === 'done') {
                this.$message.success(`${info.file.name} 上传成功`);
                this.form.logo = this.uploadData.key;
            } else if (info.file.status === 'error') {
                this.$message.error(`${info.file.name} 上传失败`);
            }
        },
        handleChange2(info) {
            if (info.file.status === 'done') {
                this.$message.success(`${info.file.name} 上传成功`);
                this.form.wxPic = this.uploadData.key;
            } else if (info.file.status === 'error') {
                this.$message.error(`${info.file.name} 上传失败`);
            }
        },
        getTemplates() {
            let that = this;
            this.$ajax.get(this.$host + "/admin/website/templates/list", {
                params: {}
            }).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.templates = result.data;
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        addSuccess() {
            let that = this;
            let text = '添加';
            if(this.$route.params.website!=='add'){
                text = '编辑';
            }
            this.$Modal.confirm({
                title: text + '网站成功',
                content: '已经成功'+text+'名为：' + this.form.title + '的网站，点击确定跳转到网站列表',
                okText: '好的',
                okType: 'danger',
                cancelText: '继续' + text,
                onOk() {
                    that.$router.push({path: "/admin/website"});
                },
                onCancel() {
                    that.resetForm();
                },
            });
        },
        addWebsite() {
            let that = this;
            this.$ajax.post(this.$host + "/admin/website/add", that.form).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.addSuccess();
                } else {
                    that.$message.warn(result.msg);
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        editWebsite() {
            let that = this;
            this.$ajax.post(this.$host + "/admin/website/edit", that.form).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.addSuccess();
                } else {
                    that.$message.warn(result.msg);
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        onSubmit() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    if(this.$route.params.website==='add'){
                        this.addWebsite();
                    }else{
                        this.editWebsite();
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
        getBaseData() {
            let that = this;
            this.$ajax.get(this.$host + "/admin/website/details", {
                params: {
                    website: this.$route.params.website
                }
            }).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.form = result.data;
                } else {
                    that.$message.info(result.msg);
                }
            }).catch(function (err) {
                console.log(err)
            });
        }
    },
    mounted() {
        this.getTemplates();
        if (this.$route.params.website !== 'add') {
            this.getBaseData();
        }
    }
}
</script>

<style scoped>

</style>